import Vue from 'vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faArchive,
  faBoxOpen,
  faCalendarCheck,
  faCamera,
  faChartBar,
  faCircle,
  faCloudUploadAlt,
  faComment,
  faCommentAltDots,
  faCopy,
  faDonate,
  faEdit,
  faEnvelope,
  faEnvelopeOpenDollar,
  faExclamationCircle,
  faEye,
  faFlag,
  faImages,
  faMinus,
  faPlus,
  faBell as fasBell,
  faEllipsisV as fasEllipsisV,
  faExclamationTriangle as fasExclamationCircle,
  faInfoCircle as fasInfoCircle,
  faSpinner,
  faUserPlus as fasUserPlus,
  faTicketAlt,
  faTimes,
  faTimesCircle,
  faToggleOn,
  faTrashAlt,
  faTrashRestore,
  faUndo,
  faCheckCircle,
} from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faAnalytics,
  faAngleDoubleUp,
  faArrowToRight,
  faBell,
  faBolt,
  faBookHeart,
  faBrain,
  faBuilding,
  faCalendarAlt,
  faCheck,
  faChevronDown,
  faClipboardList,
  faClock,
  faClone,
  faCode,
  faCog,
  faCommentAlt,
  faCommentAltDollar,
  faCommentAltLines,
  faCreditCard,
  faDownload,
  faEllipsisV,
  faEnvelopeOpenText,
  faExclamationTriangle,
  faFastForward,
  faFileInvoice,
  faFolderPlus,
  faGripLinesVertical,
  faHammer,
  faHeart,
  faHomeAlt,
  faImage,
  faInbox,
  faInboxOut,
  faInfoCircle,
  faLink,
  faMap,
  faMoneyCheck,
  faPencil,
  faPencilAlt,
  faQuestionCircle,
  faPlus as farPlus,
  faTimesCircle as farTimesCircle,
  faSack,
  faSignOutAlt,
  faSlidersH,
  faStar,
  faTable,
  faUsdCircle,
  faUser,
  faUserCircle,
  faUserPlus,
  faUsers,
} from '@fortawesome/pro-regular-svg-icons'

import { faFacebookF, faTwitter } from '@fortawesome/free-brands-svg-icons'

library.add(
  faAngleDoubleUp,
  faCheck,
  faCheckCircle,
  fasInfoCircle,
  faArchive,
  faTrashRestore,
  faEdit,
  faEye,
  faCopy,
  faTrashAlt,
  faTimes,
  faPlus,
  farPlus,
  faMinus,
  faTimesCircle,
  faInfoCircle,
  faHomeAlt,
  faAnalytics,
  faUser,
  faCommentAlt,
  faCommentAltLines,
  faPencil,
  faUsdCircle,
  faClone,
  faCog,
  faBolt,
  faQuestionCircle,
  faImage,
  faSpinner,
  faBookHeart,
  faUsers,
  faMoneyCheck,
  faFileInvoice,
  faBell,
  faCode,
  faLink,
  faInbox,
  faInboxOut,
  faClipboardList,
  faFastForward,
  faUserCircle,
  faBuilding,
  faEnvelopeOpenText,
  faCreditCard,
  faMap,
  faCommentAltDollar,
  faSignOutAlt,
  faTable,
  faEllipsisV,
  fasEllipsisV,
  faDownload,
  faChevronDown,
  fasBell,
  faStar,
  faHeart,
  faUserPlus,
  faSlidersH,
  faFolderPlus,
  faPencilAlt,
  faToggleOn,
  faImages,
  faClock,
  faEnvelope,
  fasUserPlus,
  faEnvelopeOpenDollar,
  faFacebookF,
  faTwitter,
  faCheckCircle,
  faCalendarCheck,
  faDonate,
  faCommentAltDots,
  faChartBar,
  faComment,
  faCamera,
  faExclamationCircle,
  farTimesCircle,
  faCircle,
  faBoxOpen,
  faCloudUploadAlt,
  faArrowToRight,
  faCalendarAlt,
  faHammer,
  faFlag,
  faUndo,
  faExclamationTriangle,
  fasExclamationCircle,
  faSack,
  faBrain,
  fasExclamationCircle,
  faTicketAlt,
  faGripLinesVertical
)

Vue.component('FontAwesomeIcon', FontAwesomeIcon)
